// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JobOrderHistDetail } from './job-order-hist-detail';
import { ReturnReason } from './return-reason';
import { ReturnRequest } from './return-request';
import { ReturnRequestDetailStatus } from './return-request-detail-status';
import { ReturnRequestDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnRequestDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Decimal */
  actualUnitCreditAmt?: number;
  /** Decimal */
  defaultUnitCreditAmt?: number;
  /** Guid FK jobOrderHistDetail */
  jobOrderHistDetailId!: string;
  /** Int32 */
  qty!: number;
  /** String(2000) */
  returnExplanation?: string;
  /** Guid FK returnReason */
  returnReasonId!: string;
  /** Enum FK returnRequestDetailStatus */
  returnRequestDetailStatusId!: ReturnRequestDetailStatusEnum;
  /** Guid FK returnRequest */
  returnRequestId!: string;
  /** String(2000) */
  returnStatusExplanation?: string;
  /** DateTimeOffset */
  returnStatusTs!: Date;
  /** Binary */
  rowVersion!: any;
  /** FK jobOrderHistDetailId */
  jobOrderHistDetail!: JobOrderHistDetail;
  /** FK returnReasonId */
  returnReason!: ReturnReason;
  /** FK returnRequestId */
  returnRequest!: ReturnRequest;
  /** FK returnRequestDetailStatusId */
  returnRequestDetailStatus!: ReturnRequestDetailStatus;
}

